import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import { AxiosError } from 'axios'

import showErrorToast from '@/common/utils/showErrorToast'
import useMutationCreateDailyCheckIn from '@/modules/promotion/api/hooks/useMutationCreateDailyCheckIn'
import { CreateDailyCheckInRequest } from '@/modules/promotion/type'
import DailyCheckInForm from '../../../DailyCheckInForm'
import { DailyCheckInFormValues } from '../../../DailyCheckInForm/components/FormSchema'
import { DailyCheckInQueryKeys } from '@/modules/promotion/keys'
import { useQueryClient } from '@tanstack/react-query'
import { ProviderResolutionConflictDialog } from '../../../ProviderResolutionConflictDialog'

export default function CreateDailyCheckInForm() {
	const navigate = useNavigate()
	const queryClient = useQueryClient()
	const [conflictDialogOpen, setConflictDialogOpen] = useState(false)
	const [conflictMessage, setConflictMessage] = useState('')

	const { mutate: createDailyCheckIn } = useMutationCreateDailyCheckIn({
		onSuccess: () => {
			toast.success('สร้างกิจกรรมเช็คอินรายวันสำเร็จ')
			queryClient.invalidateQueries({
				queryKey: [DailyCheckInQueryKeys.GetDailyCheckIn],
			})
			navigate('/operator/daily-check-in')
		},
		onError: (error) => {
			const axiosError = error as unknown as AxiosError<{
				message: string
				errorCode: string
			}>

			// Check if it's a provider resolution conflict error
			if (
				axiosError.isAxiosError &&
				axiosError.response?.data?.errorCode === 'PROVIDER_RESOLUTION_CONFLICT'
			) {
				setConflictMessage(axiosError.response.data.message)
				setConflictDialogOpen(true)
				return
			}

			// For other errors, show toast
			showErrorToast(error)
		},
	})

	const handleSubmit = (data: DailyCheckInFormValues) => {
		createDailyCheckIn({
			payload: {
				...data,
				turnoverRound: 1,
			} as unknown as CreateDailyCheckInRequest,
		})
	}

	return (
		<>
			<DailyCheckInForm mode="create" onSubmit={handleSubmit} />
			<ProviderResolutionConflictDialog
				isOpen={conflictDialogOpen}
				onClose={() => setConflictDialogOpen(false)}
				message={conflictMessage}
			/>
		</>
	)
}
